import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from "react-intl"

import BlockBase from '../BlockBase'
import LocalizedLink from "../../LocalizedLink"

class OpenPositions extends React.PureComponent {
    render() {
        return (
            <BlockBase id='open-positions'>
                <div className='row'>
                    <div className='col-md-12'>
                        <h5><FormattedMessage id='block--open-positions--heading'/></h5>
                        <p><FormattedMessage id='block--open-positions--description'/></p>

                        <LocalizedLink to="_open_positions" className="btn btn-blue">
                            <FormattedMessage id="block--open-positions--view-all" />
                        </LocalizedLink>
                    </div>
                </div>
            </BlockBase>
        )
    }
}

export default OpenPositions

OpenPositions.propTypes = {
    language: PropTypes.string
}